export function normalizeSlug(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export function normalizeTitle(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

export function titlesLikelyMatch(a, b) {
  const left = normalizeTitle(a);
  const right = normalizeTitle(b);
  if (!left || !right) return false;
  if (left === right) return true;
  if (left.includes(right) || right.includes(left)) return true;

  const wordsA = left.split(' ').filter((word) => word.length > 3);
  const wordsB = right.split(' ').filter((word) => word.length > 3);
  return wordsA.some((word) =>
    wordsB.some((other) => other.includes(word) || word.includes(other)),
  );
}

export function projectMatchesRoute(project, routeSlug) {
  if (!project || !routeSlug) return false;

  const normalizedRoute = normalizeSlug(routeSlug);
  const projectSlug = normalizeSlug(project.slug);

  if (projectSlug && projectSlug === normalizedRoute) return true;
  if (String(project.id) === String(routeSlug)) return true;

  const routeAsTitle = normalizeTitle(String(routeSlug).replace(/-/g, ' '));
  const projectTitle = normalizeTitle(project.title);

  if (projectTitle && routeAsTitle && titlesLikelyMatch(projectTitle, routeAsTitle)) {
    return true;
  }

  const routeLead = normalizedRoute.split('-').find(Boolean);
  if (routeLead && projectTitle.includes(routeLead)) return true;

  return false;
}

export function overviewMatchesRoute(overview, routeSlug) {
  if (!overview || !routeSlug) return false;

  const normalizedRoute = normalizeSlug(routeSlug);
  const overviewSlug = normalizeSlug(overview.slug);

  if (overviewSlug && overviewSlug === normalizedRoute) return true;
  if (String(overview.id) === String(routeSlug)) return true;

  return titlesLikelyMatch(overview.title, String(routeSlug).replace(/-/g, ' '))
    || titlesLikelyMatch(overview.title, overview.slug);
}

export function findProjectForRoute(projects, overviews, routeSlug) {
  const items = Array.isArray(projects) ? projects.filter((item) => item.isActive !== false) : [];
  const cards = Array.isArray(overviews)
    ? overviews.filter((item) => item.isActive !== false)
    : [];

  const direct = items.find((project) => projectMatchesRoute(project, routeSlug));
  if (direct) return direct;

  const overview = cards.find((card) => overviewMatchesRoute(card, routeSlug));
  if (!overview) return null;

  if (overview.projectId) {
    const linked = items.find((project) => project.id === overview.projectId);
    if (linked) return linked;
  }

  const byTitle = items.find((project) => titlesLikelyMatch(project.title, overview.title));
  if (byTitle) return byTitle;

  const sortedCards = [...cards].sort(
    (a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0),
  );
  const sortedProjects = items
    .filter((project) => !project.isFeatured)
    .sort((a, b) => a.id - b.id);

  const cardIndex = sortedCards.findIndex((card) => card.id === overview.id);
  if (cardIndex >= 0 && sortedProjects[cardIndex]) {
    return sortedProjects[cardIndex];
  }

  return null;
}

export function resolveLinkedProject(overview, projects) {
  const items = Array.isArray(projects) ? projects.filter((item) => item.isActive !== false) : [];
  if (!overview) return null;

  if (overview.projectId) {
    const linked = items.find((project) => project.id === overview.projectId);
    if (linked) return linked;
  }

  return findProjectForRoute(items, [overview], overview.slug || overview.id);
}

export function getPortfolioDetailPath(item, projects = []) {
  const linked = item?.projectId
    ? projects.find((project) => project.id === item.projectId)
    : null;
  const slug = linked?.slug || item?.slug || item?.id;
  return `/portfolio/${normalizeSlug(slug) || slug}`;
}
